import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b036d6a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_2 = { class: "bg-white w-full rounded overflow-hidden shadow-lg sm:w-6/12 text-center m-2" }
const _hoisted_3 = { class: "list-reset flex justify-center" }
const _hoisted_4 = {
  key: 0,
  class: "w-full"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "st0",
    d: "M426.489,383.022V8.311c0-2.849-1.44-5.462-3.856-7c-1.348-0.847-2.886-1.301-4.45-1.301\n\t\tc-1.214,0-2.39,0.258-3.495,0.774l-72.893,34.073L280.434,6.184l-61.309,28.673l-61.33-28.673L96.486,34.857L23.638,0.774\n\t\tC22.528,0.258,21.352,0,20.132,0c-1.574,0-3.112,0.455-4.47,1.311c-2.39,1.538-3.82,4.151-3.82,6.98l0.01,412.634\n\t\tc0.01,23.726,8.529,46.018,23.974,62.754c13.428,14.569,31.15,24.222,50.076,27.33v0.815l9.448,0.073l1.415,0.061\n\t\tc0.738,0,1.378-0.031,2.922-0.113H417.75c1.146,0.072,2.441,0.154,3.928,0.154c11.053,0,22.184-3.087,32.194-8.92\n\t\tc14.099-8.219,25.832-21.486,33.938-38.357c8.193-17.068,12.349-36.705,12.349-58.357v-23.345H426.489z M138.466,406.366\n\t\tc0.01,20.712-5.142,39.194-14.517,52.048c-3.928,5.4-8.585,9.726-13.474,12.524c-4.481,2.581-9.096,3.881-13.711,3.881\n\t\tc-0.893,0-1.797-0.03-2.757-0.165c-11.378-1.27-22.622-7.145-30.851-16.106c-9.251-10.108-14.156-23.19-14.176-37.841V53.617\n\t\tl47.504,22.218l61.309-28.661l61.33,28.661l61.309-28.661l61.361,28.661l47.566-22.218l-0.011,338.966H138.466V406.366z\n\t\t M448.594,458.393c-3.897,5.421-8.522,9.768-13.37,12.587c-4.45,2.57-9.009,3.872-13.547,3.881c-0.738,0-1.481-0.041-2.973-0.154\n\t\tH146.158c3.149-4.296,5.963-8.993,8.394-14.011c5.792-11.956,9.432-25.585,10.826-40.536h296.835\n\t\tC459.994,439.178,453.639,451.414,448.594,458.393z"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "96.083",
    y: "142.731",
    class: "st0",
    width: "248.479",
    height: "23.23"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "96.083",
    y: "230.131",
    class: "st0",
    width: "248.479",
    height: "23.241"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "96.083",
    y: "317.542",
    class: "st0",
    width: "129.02",
    height: "23.23"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("レシート")
const _hoisted_8 = {
  key: 1,
  class: "-mb-px w-full"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M18.5 4.5H16.32C16.43 4.19 16.5 3.85 16.5 3.5C16.5 1.84 15.16 0.5 13.5 0.5C12.45 0.5 11.54 1.04 11 1.85L10.5 2.52L10 1.84C9.46 1.04 8.55 0.5 7.5 0.5C5.84 0.5 4.5 1.84 4.5 3.5C4.5 3.85 4.57 4.19 4.68 4.5H2.5C1.39 4.5 0.51 5.39 0.51 6.5L0.5 17.5C0.5 18.61 1.39 19.5 2.5 19.5H18.5C19.61 19.5 20.5 18.61 20.5 17.5V6.5C20.5 5.39 19.61 4.5 18.5 4.5ZM13.5 2.5C14.05 2.5 14.5 2.95 14.5 3.5C14.5 4.05 14.05 4.5 13.5 4.5C12.95 4.5 12.5 4.05 12.5 3.5C12.5 2.95 12.95 2.5 13.5 2.5ZM8.5 3.5C8.5 2.95 8.05 2.5 7.5 2.5C6.95 2.5 6.5 2.95 6.5 3.5C6.5 4.05 6.95 4.5 7.5 4.5C8.05 4.5 8.5 4.05 8.5 3.5ZM2.5 17.5V15.5H18.5V17.5H2.5ZM2.5 7.5V12.5H18.5V7.5C18.5 6.95 18.05 6.5 17.5 6.5H13.42L14.9 8.52C15.23 8.97 15.13 9.6 14.68 9.92C14.24 10.24 13.61 10.14 13.29 9.7L10.5 5.9L7.71 9.7C7.39 10.14 6.76 10.24 6.32 9.92C5.87 9.6 5.77 8.97 6.1 8.52L7.58 6.5H3.5C2.95 6.5 2.5 6.95 2.5 7.5Z"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  class: "w-full"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.99 0.0322266C4.47 0.0322266 0 4.51223 0 10.0322C0 15.5522 4.47 20.0322 9.99 20.0322C15.52 20.0322 20 15.5522 20 10.0322C20 4.51223 15.52 0.0322266 9.99 0.0322266ZM10 18.0322C5.58 18.0322 2 14.4522 2 10.0322C2 5.61223 5.58 2.03223 10 2.03223C14.42 2.03223 18 5.61223 18 10.0322C18 14.4522 14.42 18.0322 10 18.0322ZM9.72 5.03223H9.78C10.18 5.03223 10.5 5.35223 10.5 5.75223V10.2922L14.37 12.5922C14.72 12.7922 14.83 13.2422 14.62 13.5822C14.42 13.9222 13.98 14.0222 13.64 13.8222L9.49 11.3322C9.18 11.1522 9 10.8222 9 10.4722V5.75223C9 5.35223 9.32 5.03223 9.72 5.03223Z"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 3,
  class: "w-full"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.99 0.0322266C4.47 0.0322266 0 4.51223 0 10.0322C0 15.5522 4.47 20.0322 9.99 20.0322C15.52 20.0322 20 15.5522 20 10.0322C20 4.51223 15.52 0.0322266 9.99 0.0322266ZM10 18.0322C5.58 18.0322 2 14.4522 2 10.0322C2 5.61223 5.58 2.03223 10 2.03223C14.42 2.03223 18 5.61223 18 10.0322C18 14.4522 14.42 18.0322 10 18.0322ZM9.72 5.03223H9.78C10.18 5.03223 10.5 5.35223 10.5 5.75223V10.2922L14.37 12.5922C14.72 12.7922 14.83 13.2422 14.62 13.5822C14.42 13.9222 13.98 14.0222 13.64 13.8222L9.49 11.3322C9.18 11.1522 9 10.8222 9 10.4722V5.75223C9 5.35223 9.32 5.03223 9.72 5.03223Z"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 獲得・消費履歴")
const _hoisted_18 = {
  key: 0,
  class: "w-full px-2"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" もっと見る ")
const _hoisted_20 = {
  key: 2,
  class: "text-gray-500 my-8"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "アップロードされたレシートはありません", -1))
const _hoisted_23 = {
  key: 1,
  class: "w-full px-2"
}
const _hoisted_24 = {
  key: 1,
  class: "text-gray-500 my-8"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 2,
  class: "w-full px-2 mx-auto"
}
const _hoisted_27 = {
  key: 1,
  class: "text-gray-500 my-8"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "応募履歴はありません", -1))
const _hoisted_30 = {
  key: 3,
  class: "w-full px-2 mx-auto"
}
const _hoisted_31 = {
  key: 1,
  class: "text-gray-500 my-8"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "獲得・消費履歴はありません", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReceiptChargeRequest = _resolveComponent("ReceiptChargeRequest")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_Gift = _resolveComponent("Gift")!
  const _component_ExchangeResult = _resolveComponent("ExchangeResult")!
  const _component_PointLog = _resolveComponent("PointLog")!
  const _component_BaseCard = _resolveComponent("BaseCard")!

  return (_ctx.tabCount > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            (
            _ctx.hasReceiptChargeConfig &&
            _ctx.myPageConfig?.receipt_uploading_history_visibility
          )
              ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["tab-link-base", {
              'tab-link-active': _ctx.isReceiptTabActive,
              'tab-link-inactive': !_ctx.isReceiptTabActive,
            }]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeActiveTab(_ctx.tabNames.RECEIPT)))
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      version: "1.1",
                      width: "21",
                      height: "20",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      viewBox: "0 0 512 512",
                      "xml:space": "preserve",
                      class: _normalizeClass(["tab-svg-base", {
                'tab-svg-inactive': !_ctx.isReceiptTabActive,
              }])
                    }, _hoisted_6, 2)),
                    _hoisted_7
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (_ctx.myPageConfig?.received_gift_history_option)
              ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["tab-link-base", {
              'tab-link-active': _ctx.isGiftTabActive,
              'tab-link-inactive': !_ctx.isGiftTabActive,
            }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeActiveTab(_ctx.tabNames.GIFT)))
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      width: "21",
                      height: "20",
                      viewBox: "0 0 21 20",
                      class: _normalizeClass(["tab-svg-base", {
                'tab-svg-inactive': !_ctx.isGiftTabActive,
              }]),
                      xmlns: "http://www.w3.org/2000/svg"
                    }, _hoisted_10, 2)),
                    _createTextVNode(_toDisplayString(_ctx.myPageConfig.received_gift_history_option.title), 1)
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (_ctx.myPageConfig?.exchanging_history_option)
              ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["tab-link-base", {
              'tab-link-active': _ctx.isHistoryTabActive,
              'tab-link-inactive': !_ctx.isHistoryTabActive,
            }]),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeActiveTab(_ctx.tabNames.HISTORY)))
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      width: "20",
                      height: "21",
                      viewBox: "0 0 20 21",
                      class: _normalizeClass(["tab-svg-base", {
                'tab-svg-inactive': !_ctx.isHistoryTabActive,
              }]),
                      xmlns: "http://www.w3.org/2000/svg"
                    }, _hoisted_13, 2)),
                    _createTextVNode(" " + _toDisplayString(_ctx.exchangingHistoryTitle), 1)
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            (_ctx.myPageConfig?.point_logs_option)
              ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["tab-link-base", {
              'tab-link-active': _ctx.isPointLogsTabActive,
              'tab-link-inactive': !_ctx.isPointLogsTabActive,
            }]),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeActiveTab(_ctx.tabNames.POINT_LOGS)))
                  }, [
                    (_openBlock(), _createElementBlock("svg", {
                      width: "20",
                      height: "21",
                      viewBox: "0 0 20 21",
                      class: _normalizeClass(["tab-svg-base", {
                'tab-svg-inactive': !_ctx.isPointLogsTabActive,
              }]),
                      xmlns: "http://www.w3.org/2000/svg"
                    }, _hoisted_16, 2)),
                    _hoisted_17
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_BaseCard, null, {
            default: _withCtx(() => [
              (_ctx.hasReceiptChargeConfig && _ctx.isReceiptTabActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showableChargeRequests, (chargeRequest, index) => {
                      return (_openBlock(), _createBlock(_component_ReceiptChargeRequest, {
                        key: index,
                        chargeRequest: chargeRequest
                      }, null, 8, ["chargeRequest"]))
                    }), 128)),
                    (_ctx.gettableNextChargeRequests)
                      ? (_openBlock(), _createBlock(_component_BaseButton, {
                          key: 0,
                          class: "py-2 px-10 my-3 mx-auto mr-2",
                          buttonClass: "outlined",
                          onClick: _ctx.getNextChargeRequests
                        }, {
                          default: _withCtx(() => [
                            _hoisted_19
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.isCharngeRequestsTogglable)
                      ? (_openBlock(), _createBlock(_component_BaseButton, {
                          key: 1,
                          class: "py-2 px-10 my-3 mx-auto",
                          buttonClass: "outlined",
                          onClick: _ctx.toggleReadChargeRequestsMore
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.openChargeRequestsToggle ? "たたむ" : "もっと見る"), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.showableChargeRequests.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("img", {
                            src: _ctx.informationCircle,
                            alt: "no-gifts",
                            class: "w-6 mx-auto mb-2"
                          }, null, 8, _hoisted_21),
                          _hoisted_22
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isGiftTabActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showableGifts, (showableGift, index) => {
                      return (_openBlock(), _createBlock(_component_Gift, {
                        key: index,
                        exchangeResultWithGift: showableGift,
                        receivedDateLabel: 
              _ctx.myPageConfig?.received_gift_history_option
                ?.gift_received_date_title
            
                      }, null, 8, ["exchangeResultWithGift", "receivedDateLabel"]))
                    }), 128)),
                    (_ctx.gifts.length >= 4)
                      ? (_openBlock(), _createBlock(_component_BaseButton, {
                          key: 0,
                          class: "py-2 px-10 my-3 mx-auto",
                          buttonClass: "outlined",
                          onClick: _ctx.toggleReadGiftMore
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.showFullGifts ? "たたむ" : "もっと見る"), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.showableGifts.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createElementVNode("img", {
                            src: _ctx.informationCircle,
                            alt: "no-gifts",
                            class: "w-6 mx-auto mb-2"
                          }, null, 8, _hoisted_25),
                          _createElementVNode("p", null, _toDisplayString(_ctx.myPageConfig?.received_gift_history_option?.title || "当選景品") + "はありません ", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isHistoryTabActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showableExchangeResults, (exchangeResult, index) => {
                      return (_openBlock(), _createBlock(_component_ExchangeResult, {
                        key: index,
                        exchangeResult: exchangeResult,
                        lotteryRabelVisibility: _ctx.lotteryRabelVisibility,
                        exchangingRequestDateTitle: _ctx.exchangingRequestDateTitle
                      }, null, 8, ["exchangeResult", "lotteryRabelVisibility", "exchangingRequestDateTitle"]))
                    }), 128)),
                    (_ctx.dataTimeParsedExchangeResults.length >= 6)
                      ? (_openBlock(), _createBlock(_component_BaseButton, {
                          key: 0,
                          class: "py-2 px-10 mt-0 mb-1 mx-auto",
                          buttonClass: "outlined",
                          onClick: _ctx.toggleReadExchangeResults
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.showFullExchangeResults ? "たたむ" : "もっと見る"), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.showableExchangeResults.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("img", {
                            src: _ctx.informationCircle,
                            alt: "no-gifts",
                            class: "w-6 mx-auto mb-2"
                          }, null, 8, _hoisted_28),
                          _hoisted_29
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isPointLogsTabActive)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.showableParsedPointLogs, (pointLog, index) => {
                      return (_openBlock(), _createBlock(_component_PointLog, {
                        key: index,
                        pointLog: pointLog
                      }, null, 8, ["pointLog"]))
                    }), 128)),
                    (_ctx.showableParsedPointLogs.length >= 1)
                      ? (_openBlock(), _createBlock(_component_BaseButton, {
                          key: 0,
                          class: "py-2 px-10 mt-0 mb-1 mx-auto",
                          buttonClass: "outlined",
                          onClick: _ctx.togglePointLogsMore
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.showFullPointLogs ? "たたむ" : "もっと見る"), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.showableParsedPointLogs.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createElementVNode("img", {
                            src: _ctx.informationCircle,
                            alt: "no-gifts",
                            class: "w-6 mx-auto mb-2"
                          }, null, 8, _hoisted_32),
                          _hoisted_33
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}